export default (client) => ({
  getTrialAvailability() {
    return client.get('/subscriptions/trial/availability/')
  },
  requestTrial(values) {
    return client.post('/subscriptions/trial/signup/', values)
  },
  getWorkspaceSubscription(workspaceId) {
    return client.get(`/subscriptions/workspace/${workspaceId}/`)
  },
  getAdminWorkspaceSubscription(workspaceId) {
    return client.get(`/subscriptions/admin/workspace/${workspaceId}/`)
  },
  changeAdminWorkspaceSubscription(workspaceId, values) {
    return client.post(`/subscriptions/admin/workspace/${workspaceId}/`, values)
  },
})
